<template>
  <div>
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- LIBERA O STATUS DA PAGINA -->
    <template v-else-if='statusGeral === ""'>
      <div class="sub-ger-clu-pri">
        <div class="titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          CONFIGURAÇÕES GERAIS
          <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
        </div>

        <div class="quadrado habilitada">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <svg class="fas fa-heartbeat"></svg>
              Habilitada
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              <template v-if="editar.hab.status === ''">
                <!-- SETA O BOTÃO EDITAR -->
                <App-Button v-if="editar.hab.value === false" :cpntIcone="'editar'" :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { subGerCluPriEditarCampo('hab') }"></App-Button>
  
                <!-- SETA O BOTÃO MODIFICAR -->
                <App-Button v-if="editar.hab.value === true" :cpntIcone="'cancelar'" :cpntClass="'btn btn-default btn-sm'" @onClick="() => { subGerCluPriEditarCampo('hab') }"></App-Button>
              </template>
            </div>
          </div>
          <div class="conteudo">
            <template v-if="editar.hab.status !== ''">
              <RF-Status :cpntStatus='editar.hab.status' :cpntTamanho='5'></RF-Status>
            </template>
            <div :data-time="time" v-else-if="editar.hab.value === true" class="editar">
              <!-- ESCOLHE A OPÇÃO -->
              <App-Select :data-time="time" :class='(campos.hab_seletor.value === "0" || campos.hab_seletor.value.id === "0" ? "reduzido" : "")'
                :cpntStatus='campos.hab_seletor.status'
                :cpntId='campos.hab_seletor.id'
                :cpntTabIndex='campos.hab_seletor.tabIndex'
                :cpntNome='campos.hab_seletor.nome'
                :cpntValue='campos.hab_seletor.value'
                :cpntMensagem='campos.hab_seletor.mensagem'
                :cpntMensagemTipo='campos.hab_seletor.mensagemTipo'
                :cpntDisabled='campos.hab_seletor.disabled'
                :cpntMostrar='campos.hab_seletor.mostrar'
                :cpntExplica='campos.hab_seletor.explica'
                :cpntPlaceholder='campos.hab_seletor.placeholder'
                :cpntValueRef='campos.hab_seletor.valueRef'
                :cpntRouter='campos.hab_seletor.router'
                :cpntMethod='campos.hab_seletor.method'
                :cpntField='campos.hab_seletor.field'
                :cpntWhere='campos.hab_seletor.where'
                :cpntAddButForm='campos.hab_seletor.addButForm'
                :cpntKeyMostra='campos.hab_seletor.keyMostra'
                :cpntTipoOrder='campos.hab_seletor.tipoOrder'
                :cpntOrder='campos.hab_seletor.order'
                :cpntOptions='campos.hab_seletor.options'
                :cpntKeyValue='campos.hab_seletor.keyValue'
                :cpntSearchMinimo='campos.hab_seletor.searchMinimo'
                :cpntMask='campos.hab_seletor.mask'
                :cpntOptionInicialNome='campos.hab_seletor.optionInicialNome'
                :cpntOptionInicialValue='campos.hab_seletor.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "hab_seletor") }'
                :ref='"hab_seletor"'
              ></App-Select>

              <!-- VERIFICA SE SERÁ BLOQUEIO -->
              <template v-if='campos.hab_seletor.value === "0" || campos.hab_seletor.value.id === "0"'>
                <!-- SETA O CALENDARIO PARA ESCOLHA DA DATA -->
                <App-Calendario :data-time="time"
                  :cpntStatus='campos.hab_input.status'
                  :cpntId='campos.hab_input.id'
                  :cpntClassDivField='campos.hab_input.classDivField'
                  :cpntNome='campos.hab_input.nome'
                  :cpntValue='campos.hab_input.value'
                  :cpntAutoComplete='campos.hab_input.autocomplete'
                  :cpntMask='campos.hab_input.mask'
                  :cpntDisabled='campos.hab_input.disabled'
                  :cpntMostrar='campos.hab_input.mostrar'
                  :cpntAutoFocus='campos.hab_input.autofocus'
                  :cpntMensagem='campos.hab_input.mensagem'
                  :cpntMensagemTipo='campos.hab_input.mensagemTipo'
                  :cpntPlaceholder='campos.hab_input.placeholder'
                  :cpntExplica='campos.hab_input.explica'
                  :cpntConfig='campos.hab_input.config'
                  :cpntPosicionar='campos.hab_input.posicionar'
                  :cpntTabIndex='campos.hab_input.tabIndex'

                  :cpntOnChange='(value) => { subGerCluPriOnChange(value, "hab_input") }'
                  :ref='"hab_input"'
                ></App-Calendario>

                <!-- SETA A FRASE DE BLOQUEIO -->
                <div v-html="subGerCluPriFraseBloqueio" class="frase"></div>
              </template>
              
              <!-- SETA O BOTÃO SALVAR -->
              <App-Button :data-time="time" @onClick="() => { subGerCluPriAtualizarHabilitada() }" :cpntClass="'btn btn-primary btn-sm'">
                Salvar
              </App-Button>
            </div>
            <template v-else-if="cpntHabilitada === '1'">
              <!-- SETA O ICONE -->
              <App-Icone :cpntTipo="'check-verde'"></App-Icone>

              <!-- SETA A FRASE -->
              <!-- <div>
                &nbsp;
              </div> -->
            </template>
            <template v-else-if="cpntHabilitada === '2'">
              <!-- SETA O ICONE -->
              <App-Icone :cpntTipo="'erro-vermelho'"></App-Icone>

              <!-- SETA A FRASE -->
              <div>
                Licença de uso <b>Cancelada</b>
              </div>
            </template>
            <template v-else-if="cpntDataBlockDiff <= -90">
              <!-- SETA O ICONE -->
              <App-Icone :cpntTipo="'alerta-vermelho'"></App-Icone>

              <!-- SETA A FRASE -->
              <div>
                <b>Cancelado</b>, através de bloqueio desde o dia {{ cpntDataBlock }}
              </div>
            </template>
            <template v-else-if="cpntDataBlockDiff <= 0">
              <!-- SETA O ICONE -->
              <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>

              <!-- SETA A FRASE -->
              <div>
                <b>Bloqueado</b> desde o dia {{ cpntDataBlock }}
              </div>
            </template>
            <template v-else-if="cpntDataBlockDiff > 0">
              <!-- SETA O ICONE -->
              <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>

              <!-- SETA A FRASE -->
              <div>
                <b>Bloquear</b> a partir do dia {{ cpntDataBlock }}.
              </div>
            </template>
          </div>
        </div>

        <div class="quadrado contrato">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <svg class="fas fa-file-contract"></svg>
              Contrato
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              &nbsp;
            </div>
          </div>
          <div class="conteudo frase">
            <table>
              <tr>
                <td>
                  <App-Icone v-if="(cpntContratoContadorFree === true || [ '', null, undefined ].indexOf(cpntContratoLicencaUso) === -1)" :cpntTipo="'check-verde'"></App-Icone>
                  <App-Icone v-else-if="[ '', null, undefined ].indexOf(cpntContratoDemonstrativo) === -1" :cpntTipo="'alerta-amarelo'"></App-Icone>
                </td>
                <td>
                  <span v-if="cpntContratoContadorFree === true">
                    Contador Free
                  </span>
                  <span v-else-if="[ '', null, undefined ].indexOf(cpntContratoLicencaUso) === -1">
                    Licença de uso aceite em <span v-html='cpntContratoLicencaUso'></span>.
                  </span>
                  <span v-else-if="[ '', null, undefined ].indexOf(cpntContratoDemonstrativo) === -1">
                    Demonstrativo aceite em <span v-html='cpntContratoDemonstrativo'></span>
                  </span>
                  <span v-else>---</span>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="quadrado certificado">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <svg class="fas fa-medal"></svg>
              Certificado Digital
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              &nbsp;
            </div>
          </div>
          <div class="conteudo">
            <table v-if="[ '', null, undefined ].indexOf(cpntDataCertificado) === -1">
              <tr>
                <td class="icone">
                  <App-Icone v-if="cpntDataCertificadoDiff <= 0" :cpntTipo="'erro-vermelho'"></App-Icone>
                  <App-Icone v-else-if="cpntDataCertificadoDiff <= 1" :cpntTipo="'alerta-vermelho'"></App-Icone>
                  <App-Icone v-else-if="cpntDataCertificadoDiff <= 30" :cpntTipo="'alerta-amarelo'"></App-Icone>
                  <App-Icone v-else :cpntTipo="'check-verde'"></App-Icone>
                </td>
                <td class="frase">
                  <span v-html="subGerCluPriFraseCertificado"></span>
                </td>
              </tr>
            </table>
            <div v-else>---</div>
          </div>
        </div>
        
        <div class="quadrado dias">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <i class="fa fa-vial"></i>
              Nº dias teste
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              <template v-if="editar.ndias.status === ''">
                <!-- SETA O BOTÃO EDITAR -->
                <App-Button v-if="editar.ndias.value === false" :cpntIcone="'editar'" :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { subGerCluPriEditarCampo('ndias') }"></App-Button>
  
                <!-- SETA O BOTÃO MODIFICAR -->
                <App-Button v-if="editar.ndias.value === true" :cpntIcone="'cancelar'" :cpntClass="'btn btn-default btn-sm'" @onClick="() => { subGerCluPriEditarCampo('ndias') }"></App-Button>
              </template>
            </div>
          </div>
          <div class="conteudo">
            <template v-if="editar.ndias.status !== ''">
              <RF-Status :cpntStatus='editar.ndias.status' :cpntTamanho='5'></RF-Status>
            </template>
            <div :data-time="time" v-else-if="editar.ndias.value === true" class="editar">
              <!-- ESCOLHE A OPÇÃO -->
              <App-Input :data-time="time"
                :cpntStatus='campos.ndias.status'
                :cpntId='campos.ndias.id'
                :cpntTabIndex='campos.ndias.tabIndex'
                :cpntNome='campos.ndias.nome'
                :cpntValue='campos.ndias.value'
                :cpntMensagem='campos.ndias.mensagem'
                :cpntMensagemTipo='campos.ndias.mensagemTipo'
                :cpntDisabled='campos.ndias.disabled'
                :cpntMostrar='campos.ndias.mostrar'
                :cpntExplica='campos.ndias.explica'
                :cpntPlaceholder='campos.ndias.placeholder'
                :cpntValueRef='campos.ndias.valueRef'
                :cpntRouter='campos.ndias.router'
                :cpntMethod='campos.ndias.method'
                :cpntField='campos.ndias.field'
                :cpntWhere='campos.ndias.where'
                :cpntAddButForm='campos.ndias.addButForm'
                :cpntKeyMostra='campos.ndias.keyMostra'
                :cpntTipoOrder='campos.ndias.tipoOrder'
                :cpntOrder='campos.ndias.order'
                :cpntOptions='campos.ndias.options'
                :cpntKeyValue='campos.ndias.keyValue'
                :cpntSearchMinimo='campos.ndias.searchMinimo'
                :cpntMask='campos.ndias.mask'
                :cpntOptionInicialNome='campos.ndias.optionInicialNome'
                :cpntOptionInicialValue='campos.ndias.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "ndias") }'
                :ref='"ndias"'
              ></App-Input>
              
              <!-- SETA O BOTÃO SALVAR -->
              <App-Button :data-time="time" @onClick="() => { subGerCluPriAtualizarDiasTeste() }" :cpntClass="'btn btn-primary btn-sm'">
                Salvar
              </App-Button>
            </div>
            <template v-else>
              O cliente pode realizar testes por {{ cpntDiasTeste }} dia{{ cpntDiasTeste >= 2 ? 's' : '' }} corridos<br/>para pacotes ou contrato demonstrativo.
            </template>
          </div>
        </div>
        
        <div class="quadrado senha">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div style="width: 100% !important;">
              <i class="fas fa-exchange-alt"></i>
              Reset senha SuporteRF
            </div>
          </div>
          <div class="conteudo">
            <template v-if="editar.senha.status !== ''">
              <RF-Status :cpntStatus='editar.senha.status' :cpntTamanho='5'></RF-Status>
            </template>
            <template v-else>
              <App-Button :data-time="time" @onClick="() => { subGerCluPriAtualizarSenhaSuporteRF() }" :cpntClass="'btn btn-default btn-sm'">
                Clique aqui, para atualizar<br/>a senha do SuporteRF
              </App-Button>
            </template>
          </div>
        </div>

        <hr/>

        <div class="titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          CONFIGURAÇÕES DE NOTA FISCAL
          <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
        </div>

        <div class="quadrado notas">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <svg class="fa fa-comment-dots"></svg>
              NF-e [55]
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              <template v-if="editar.nfe.status === ''">
                <!-- SETA O BOTÃO EDITAR -->
                <App-Button v-if="editar.nfe.value === false" :cpntIcone="'editar'" :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { subGerCluPriEditarCampo('nfe') }"></App-Button>
  
                <!-- SETA O BOTÃO MODIFICAR -->
                <App-Button v-if="editar.nfe.value === true" :cpntIcone="'cancelar'" :cpntClass="'btn btn-default btn-sm'" @onClick="() => { subGerCluPriEditarCampo('nfe') }"></App-Button>
              </template>
            </div>
          </div>
          <div class="conteudo">
            <template v-if="editar.nfe.status !== ''">
              <RF-Status :cpntStatus='editar.nfe.status' :cpntTamanho='5'></RF-Status>
            </template>
            <div :data-time="time" v-else-if="editar.nfe.value === true" class="editar">
              <!-- ESCOLHE A OPÇÃO -->
              <App-Select :data-time="time"
                :cpntStatus='campos.nfe_emissor.status'
                :cpntId='campos.nfe_emissor.id'
                :cpntTabIndex='campos.nfe_emissor.tabIndex'
                :cpntNome='campos.nfe_emissor.nome'
                :cpntValue='campos.nfe_emissor.value'
                :cpntMensagem='campos.nfe_emissor.mensagem'
                :cpntMensagemTipo='campos.nfe_emissor.mensagemTipo'
                :cpntDisabled='campos.nfe_emissor.disabled'
                :cpntMostrar='campos.nfe_emissor.mostrar'
                :cpntExplica='campos.nfe_emissor.explica'
                :cpntPlaceholder='campos.nfe_emissor.placeholder'
                :cpntValueRef='campos.nfe_emissor.valueRef'
                :cpntRouter='campos.nfe_emissor.router'
                :cpntMethod='campos.nfe_emissor.method'
                :cpntField='campos.nfe_emissor.field'
                :cpntWhere='campos.nfe_emissor.where'
                :cpntAddButForm='campos.nfe_emissor.addButForm'
                :cpntKeyMostra='campos.nfe_emissor.keyMostra'
                :cpntTipoOrder='campos.nfe_emissor.tipoOrder'
                :cpntOrder='campos.nfe_emissor.order'
                :cpntOptions='campos.nfe_emissor.options'
                :cpntKeyValue='campos.nfe_emissor.keyValue'
                :cpntSearchMinimo='campos.nfe_emissor.searchMinimo'
                :cpntMask='campos.nfe_emissor.mask'
                :cpntOptionInicialNome='campos.nfe_emissor.optionInicialNome'
                :cpntOptionInicialValue='campos.nfe_emissor.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfe_emissor") }'
                :ref='"nfe_emissor"'
              ></App-Select>

              <App-Select :data-time="time"
                :cpntStatus='campos.nfe_ambiente.status'
                :cpntId='campos.nfe_ambiente.id'
                :cpntTabIndex='campos.nfe_ambiente.tabIndex'
                :cpntNome='campos.nfe_ambiente.nome'
                :cpntValue='campos.nfe_ambiente.value'
                :cpntMensagem='campos.nfe_ambiente.mensagem'
                :cpntMensagemTipo='campos.nfe_ambiente.mensagemTipo'
                :cpntDisabled='campos.nfe_ambiente.disabled'
                :cpntMostrar='campos.nfe_ambiente.mostrar'
                :cpntExplica='campos.nfe_ambiente.explica'
                :cpntPlaceholder='campos.nfe_ambiente.placeholder'
                :cpntValueRef='campos.nfe_ambiente.valueRef'
                :cpntRouter='campos.nfe_ambiente.router'
                :cpntMethod='campos.nfe_ambiente.method'
                :cpntField='campos.nfe_ambiente.field'
                :cpntWhere='campos.nfe_ambiente.where'
                :cpntAddButForm='campos.nfe_ambiente.addButForm'
                :cpntKeyMostra='campos.nfe_ambiente.keyMostra'
                :cpntTipoOrder='campos.nfe_ambiente.tipoOrder'
                :cpntOrder='campos.nfe_ambiente.order'
                :cpntOptions='campos.nfe_ambiente.options'
                :cpntKeyValue='campos.nfe_ambiente.keyValue'
                :cpntSearchMinimo='campos.nfe_ambiente.searchMinimo'
                :cpntMask='campos.nfe_ambiente.mask'
                :cpntOptionInicialNome='campos.nfe_ambiente.optionInicialNome'
                :cpntOptionInicialValue='campos.nfe_ambiente.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfe_ambiente") }'
                :ref='"nfe_ambiente"'
              ></App-Select>

              <App-Select :data-time="time" class="seletor-cobranca" v-if="subGerCluPriValorSelEmissorNFe !== 'rf' && subGerCluPriValorSelAmbienteNFe === '1'"
                :cpntStatus='campos.nfe_cobranca.status'
                :cpntId='campos.nfe_cobranca.id'
                :cpntTabIndex='campos.nfe_cobranca.tabIndex'
                :cpntNome='campos.nfe_cobranca.nome'
                :cpntValue='campos.nfe_cobranca.value'
                :cpntMensagem='campos.nfe_cobranca.mensagem'
                :cpntMensagemTipo='campos.nfe_cobranca.mensagemTipo'
                :cpntDisabled='campos.nfe_cobranca.disabled'
                :cpntMostrar='campos.nfe_cobranca.mostrar'
                :cpntExplica='campos.nfe_cobranca.explica'
                :cpntPlaceholder='campos.nfe_cobranca.placeholder'
                :cpntValueRef='campos.nfe_cobranca.valueRef'
                :cpntRouter='campos.nfe_cobranca.router'
                :cpntMethod='campos.nfe_cobranca.method'
                :cpntField='campos.nfe_cobranca.field'
                :cpntWhere='campos.nfe_cobranca.where'
                :cpntAddButForm='campos.nfe_cobranca.addButForm'
                :cpntKeyMostra='campos.nfe_cobranca.keyMostra'
                :cpntTipoOrder='campos.nfe_cobranca.tipoOrder'
                :cpntOrder='campos.nfe_cobranca.order'
                :cpntOptions='campos.nfe_cobranca.options'
                :cpntKeyValue='campos.nfe_cobranca.keyValue'
                :cpntSearchMinimo='campos.nfe_cobranca.searchMinimo'
                :cpntMask='campos.nfe_cobranca.mask'
                :cpntOptionInicialNome='campos.nfe_cobranca.optionInicialNome'
                :cpntOptionInicialValue='campos.nfe_cobranca.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfe_cobranca") }'
                :ref='"nfe_cobranca"'
              ></App-Select>
              
              <!-- SETA O BOTÃO SALVAR -->
              <App-Button :data-time="time" @onClick="() => { subGerCluPriAtualizarDadosNotaFiscal('nfe') }" :cpntClass="'btn btn-primary btn-sm'">
                Salvar
              </App-Button>
            </div>
            <template v-else>
              <div>
                Emissor: <img :src="'/img/logo_' + cpntNFeEmissor + '.png'" :title="subGerCluPriFraseEmissorNFe"/>
              </div>
              <div>
                Ambiente: <span v-html="subGerCluPriFraseAmbienteNFe"></span>
              </div>
              <div v-if="cpntNFeEmissor !== 'rf' && cpntNFeAmbiente === 'Producao'">
                Cobrança: <span v-html="subGerCluPriFraseCobrancaNFe"></span>
              </div>
            </template>
          </div>
        </div>

        <div class="quadrado notas">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <svg class="fa fa-comment-dots"></svg>
              NFC-e [65]
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              <template v-if="editar.nfce.status === ''">
                <!-- SETA O BOTÃO EDITAR -->
                <App-Button v-if="editar.nfce.value === false" :cpntIcone="'editar'" :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { subGerCluPriEditarCampo('nfce') }"></App-Button>
  
                <!-- SETA O BOTÃO MODIFICAR -->
                <App-Button v-if="editar.nfce.value === true" :cpntIcone="'cancelar'" :cpntClass="'btn btn-default btn-sm'" @onClick="() => { subGerCluPriEditarCampo('nfce') }"></App-Button>
              </template>
            </div>
          </div>
          <div class="conteudo">
            <template v-if="editar.nfce.status !== ''">
              <RF-Status :cpntStatus='editar.nfce.status' :cpntTamanho='5'></RF-Status>
            </template>
            <div :data-time="time" v-else-if="editar.nfce.value === true" class="editar">
              <!-- ESCOLHE A OPÇÃO -->
              <App-Select :data-time="time"
                :cpntStatus='campos.nfce_emissor.status'
                :cpntId='campos.nfce_emissor.id'
                :cpntTabIndex='campos.nfce_emissor.tabIndex'
                :cpntNome='campos.nfce_emissor.nome'
                :cpntValue='campos.nfce_emissor.value'
                :cpntMensagem='campos.nfce_emissor.mensagem'
                :cpntMensagemTipo='campos.nfce_emissor.mensagemTipo'
                :cpntDisabled='campos.nfce_emissor.disabled'
                :cpntMostrar='campos.nfce_emissor.mostrar'
                :cpntExplica='campos.nfce_emissor.explica'
                :cpntPlaceholder='campos.nfce_emissor.placeholder'
                :cpntValueRef='campos.nfce_emissor.valueRef'
                :cpntRouter='campos.nfce_emissor.router'
                :cpntMethod='campos.nfce_emissor.method'
                :cpntField='campos.nfce_emissor.field'
                :cpntWhere='campos.nfce_emissor.where'
                :cpntAddButForm='campos.nfce_emissor.addButForm'
                :cpntKeyMostra='campos.nfce_emissor.keyMostra'
                :cpntTipoOrder='campos.nfce_emissor.tipoOrder'
                :cpntOrder='campos.nfce_emissor.order'
                :cpntOptions='campos.nfce_emissor.options'
                :cpntKeyValue='campos.nfce_emissor.keyValue'
                :cpntSearchMinimo='campos.nfce_emissor.searchMinimo'
                :cpntMask='campos.nfce_emissor.mask'
                :cpntOptionInicialNome='campos.nfce_emissor.optionInicialNome'
                :cpntOptionInicialValue='campos.nfce_emissor.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfce_emissor") }'
                :ref='"nfce_emissor"'
              ></App-Select>

              <App-Select :data-time="time"
                :cpntStatus='campos.nfce_ambiente.status'
                :cpntId='campos.nfce_ambiente.id'
                :cpntTabIndex='campos.nfce_ambiente.tabIndex'
                :cpntNome='campos.nfce_ambiente.nome'
                :cpntValue='campos.nfce_ambiente.value'
                :cpntMensagem='campos.nfce_ambiente.mensagem'
                :cpntMensagemTipo='campos.nfce_ambiente.mensagemTipo'
                :cpntDisabled='campos.nfce_ambiente.disabled'
                :cpntMostrar='campos.nfce_ambiente.mostrar'
                :cpntExplica='campos.nfce_ambiente.explica'
                :cpntPlaceholder='campos.nfce_ambiente.placeholder'
                :cpntValueRef='campos.nfce_ambiente.valueRef'
                :cpntRouter='campos.nfce_ambiente.router'
                :cpntMethod='campos.nfce_ambiente.method'
                :cpntField='campos.nfce_ambiente.field'
                :cpntWhere='campos.nfce_ambiente.where'
                :cpntAddButForm='campos.nfce_ambiente.addButForm'
                :cpntKeyMostra='campos.nfce_ambiente.keyMostra'
                :cpntTipoOrder='campos.nfce_ambiente.tipoOrder'
                :cpntOrder='campos.nfce_ambiente.order'
                :cpntOptions='campos.nfce_ambiente.options'
                :cpntKeyValue='campos.nfce_ambiente.keyValue'
                :cpntSearchMinimo='campos.nfce_ambiente.searchMinimo'
                :cpntMask='campos.nfce_ambiente.mask'
                :cpntOptionInicialNome='campos.nfce_ambiente.optionInicialNome'
                :cpntOptionInicialValue='campos.nfce_ambiente.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfce_ambiente") }'
                :ref='"nfce_ambiente"'
              ></App-Select>
              
              <App-Select :data-time="time" class="seletor-cobranca" v-if="subGerCluPriValorSelEmissorNFCe !== 'rf' && subGerCluPriValorSelAmbienteNFCe === '1'"
                :cpntStatus='campos.nfce_cobranca.status'
                :cpntId='campos.nfce_cobranca.id'
                :cpntTabIndex='campos.nfce_cobranca.tabIndex'
                :cpntNome='campos.nfce_cobranca.nome'
                :cpntValue='campos.nfce_cobranca.value'
                :cpntMensagem='campos.nfce_cobranca.mensagem'
                :cpntMensagemTipo='campos.nfce_cobranca.mensagemTipo'
                :cpntDisabled='campos.nfce_cobranca.disabled'
                :cpntMostrar='campos.nfce_cobranca.mostrar'
                :cpntExplica='campos.nfce_cobranca.explica'
                :cpntPlaceholder='campos.nfce_cobranca.placeholder'
                :cpntValueRef='campos.nfce_cobranca.valueRef'
                :cpntRouter='campos.nfce_cobranca.router'
                :cpntMethod='campos.nfce_cobranca.method'
                :cpntField='campos.nfce_cobranca.field'
                :cpntWhere='campos.nfce_cobranca.where'
                :cpntAddButForm='campos.nfce_cobranca.addButForm'
                :cpntKeyMostra='campos.nfce_cobranca.keyMostra'
                :cpntTipoOrder='campos.nfce_cobranca.tipoOrder'
                :cpntOrder='campos.nfce_cobranca.order'
                :cpntOptions='campos.nfce_cobranca.options'
                :cpntKeyValue='campos.nfce_cobranca.keyValue'
                :cpntSearchMinimo='campos.nfce_cobranca.searchMinimo'
                :cpntMask='campos.nfce_cobranca.mask'
                :cpntOptionInicialNome='campos.nfce_cobranca.optionInicialNome'
                :cpntOptionInicialValue='campos.nfce_cobranca.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfce_cobranca") }'
                :ref='"nfce_cobranca"'
              ></App-Select>
              
              <!-- SETA O BOTÃO SALVAR -->
              <App-Button :data-time="time" @onClick="() => { subGerCluPriAtualizarDadosNotaFiscal('nfce') }" :cpntClass="'btn btn-primary btn-sm'">
                Salvar
              </App-Button>
            </div>
            <template v-else>
              <div>
                Emissor: <img :src="'/img/logo_' + cpntNFCeEmissor + '.png'" :title="subGerCluPriFraseEmissorNFCe"/>
              </div>
              <div>
                Ambiente: <span v-html="subGerCluPriFraseAmbienteNFCe"></span>
              </div>
              <div v-if="cpntNFCeEmissor !== 'rf' && cpntNFCeAmbiente === 'Producao'">
                Cobrança: <span v-html="subGerCluPriFraseCobrancaNFCe"></span>
              </div>
            </template>
          </div>
        </div>

        <div class="quadrado notas">
          <div class="titulo">
            <!-- SETA O TITULO DO CAMPO -->
            <div>
              <svg class="fa fa-comment-dots"></svg>
              NFS-e
            </div>

            <!-- SETA AS AÇÕES DO CAMPO -->
            <div>
              <template v-if="editar.nfse.status === ''">
                <!-- SETA O BOTÃO EDITAR -->
                <App-Button v-if="editar.nfse.value === false" :cpntIcone="'editar'" :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { subGerCluPriEditarCampo('nfse') }"></App-Button>
  
                <!-- SETA O BOTÃO MODIFICAR -->
                <App-Button v-if="editar.nfse.value === true" :cpntIcone="'cancelar'" :cpntClass="'btn btn-default btn-sm'" @onClick="() => { subGerCluPriEditarCampo('nfse') }"></App-Button>
              </template>
            </div>
          </div>
          <div class="conteudo">
            <template v-if="editar.nfse.status !== ''">
              <RF-Status :cpntStatus='editar.nfse.status' :cpntTamanho='5'></RF-Status>
            </template>
            <div :data-time="time" v-else-if="editar.nfse.value === true" class="editar">
              <!-- ESCOLHE A OPÇÃO -->
              <App-Select :data-time="time"
                :cpntStatus='campos.nfse_emissor.status'
                :cpntId='campos.nfse_emissor.id'
                :cpntTabIndex='campos.nfse_emissor.tabIndex'
                :cpntNome='campos.nfse_emissor.nome'
                :cpntValue='campos.nfse_emissor.value'
                :cpntMensagem='campos.nfse_emissor.mensagem'
                :cpntMensagemTipo='campos.nfse_emissor.mensagemTipo'
                :cpntDisabled='campos.nfse_emissor.disabled'
                :cpntMostrar='campos.nfse_emissor.mostrar'
                :cpntExplica='campos.nfse_emissor.explica'
                :cpntPlaceholder='campos.nfse_emissor.placeholder'
                :cpntValueRef='campos.nfse_emissor.valueRef'
                :cpntRouter='campos.nfse_emissor.router'
                :cpntMethod='campos.nfse_emissor.method'
                :cpntField='campos.nfse_emissor.field'
                :cpntWhere='campos.nfse_emissor.where'
                :cpntAddButForm='campos.nfse_emissor.addButForm'
                :cpntKeyMostra='campos.nfse_emissor.keyMostra'
                :cpntTipoOrder='campos.nfse_emissor.tipoOrder'
                :cpntOrder='campos.nfse_emissor.order'
                :cpntOptions='campos.nfse_emissor.options'
                :cpntKeyValue='campos.nfse_emissor.keyValue'
                :cpntSearchMinimo='campos.nfse_emissor.searchMinimo'
                :cpntMask='campos.nfse_emissor.mask'
                :cpntOptionInicialNome='campos.nfse_emissor.optionInicialNome'
                :cpntOptionInicialValue='campos.nfse_emissor.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfse_emissor") }'
                :ref='"nfse_emissor"'
              ></App-Select>

              <App-Select :data-time="time"
                :cpntStatus='campos.nfse_ambiente.status'
                :cpntId='campos.nfse_ambiente.id'
                :cpntTabIndex='campos.nfse_ambiente.tabIndex'
                :cpntNome='campos.nfse_ambiente.nome'
                :cpntValue='campos.nfse_ambiente.value'
                :cpntMensagem='campos.nfse_ambiente.mensagem'
                :cpntMensagemTipo='campos.nfse_ambiente.mensagemTipo'
                :cpntDisabled='campos.nfse_ambiente.disabled'
                :cpntMostrar='campos.nfse_ambiente.mostrar'
                :cpntExplica='campos.nfse_ambiente.explica'
                :cpntPlaceholder='campos.nfse_ambiente.placeholder'
                :cpntValueRef='campos.nfse_ambiente.valueRef'
                :cpntRouter='campos.nfse_ambiente.router'
                :cpntMethod='campos.nfse_ambiente.method'
                :cpntField='campos.nfse_ambiente.field'
                :cpntWhere='campos.nfse_ambiente.where'
                :cpntAddButForm='campos.nfse_ambiente.addButForm'
                :cpntKeyMostra='campos.nfse_ambiente.keyMostra'
                :cpntTipoOrder='campos.nfse_ambiente.tipoOrder'
                :cpntOrder='campos.nfse_ambiente.order'
                :cpntOptions='campos.nfse_ambiente.options'
                :cpntKeyValue='campos.nfse_ambiente.keyValue'
                :cpntSearchMinimo='campos.nfse_ambiente.searchMinimo'
                :cpntMask='campos.nfse_ambiente.mask'
                :cpntOptionInicialNome='campos.nfse_ambiente.optionInicialNome'
                :cpntOptionInicialValue='campos.nfse_ambiente.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfse_ambiente") }'
                :ref='"nfse_ambiente"'
              ></App-Select>

              <App-Select :data-time="time" class="seletor-cobranca" v-if="subGerCluPriValorSelEmissorNFSe !== 'rf' && subGerCluPriValorSelAmbienteNFSe === '1'"
                :cpntStatus='campos.nfse_cobranca.status'
                :cpntId='campos.nfse_cobranca.id'
                :cpntTabIndex='campos.nfse_cobranca.tabIndex'
                :cpntNome='campos.nfse_cobranca.nome'
                :cpntValue='campos.nfse_cobranca.value'
                :cpntMensagem='campos.nfse_cobranca.mensagem'
                :cpntMensagemTipo='campos.nfse_cobranca.mensagemTipo'
                :cpntDisabled='campos.nfse_cobranca.disabled'
                :cpntMostrar='campos.nfse_cobranca.mostrar'
                :cpntExplica='campos.nfse_cobranca.explica'
                :cpntPlaceholder='campos.nfse_cobranca.placeholder'
                :cpntValueRef='campos.nfse_cobranca.valueRef'
                :cpntRouter='campos.nfse_cobranca.router'
                :cpntMethod='campos.nfse_cobranca.method'
                :cpntField='campos.nfse_cobranca.field'
                :cpntWhere='campos.nfse_cobranca.where'
                :cpntAddButForm='campos.nfse_cobranca.addButForm'
                :cpntKeyMostra='campos.nfse_cobranca.keyMostra'
                :cpntTipoOrder='campos.nfse_cobranca.tipoOrder'
                :cpntOrder='campos.nfse_cobranca.order'
                :cpntOptions='campos.nfse_cobranca.options'
                :cpntKeyValue='campos.nfse_cobranca.keyValue'
                :cpntSearchMinimo='campos.nfse_cobranca.searchMinimo'
                :cpntMask='campos.nfse_cobranca.mask'
                :cpntOptionInicialNome='campos.nfse_cobranca.optionInicialNome'
                :cpntOptionInicialValue='campos.nfse_cobranca.optionInicialValue'

                :cpntOnChange='(value) => { subGerCluPriOnChange(value, "nfse_cobranca") }'
                :ref='"nfse_cobranca"'
              ></App-Select>
              
              <!-- SETA O BOTÃO SALVAR -->
              <App-Button :data-time="time" @onClick="() => { subGerCluPriAtualizarDadosNotaFiscal('nfse') }" :cpntClass="'btn btn-primary btn-sm'">
                Salvar
              </App-Button>
            </div>
            <template v-else>
              <div>
                Emissor: <img :src="'/img/logo_' + cpntNFSeEmissor + '.png'" :title="subGerCluPriFraseEmissorNFSe"/>
              </div>
              <div>
                Ambiente: <span v-html="subGerCluPriFraseAmbienteNFSe"></span>
              </div>
              <div v-if="cpntNFSeEmissor !== 'rf' && cpntNFSeAmbiente === 'Producao'">
                Cobrança: <span v-html="subGerCluPriFraseCobrancaNFSe"></span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .sub-ger-clu-pri {
    margin-top: 5px;
    text-align: center;
  }
    .sub-ger-clu-pri > .titulo {
      text-align: center;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .sub-ger-clu-pri > hr {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .sub-ger-clu-pri > .quadrado {
      width: calc((100% / 3) - 10px);
    }
    .sub-ger-clu-pri > .quadrado {
      text-align: left;
      vertical-align: top;
      border: 1px solid #ccc;
      border-radius: 5px;
      display: inline-block;
      margin: 5px;
    }
      .sub-ger-clu-pri > .quadrado > .titulo {
        background: #e9e9e9;
        border-bottom: 1px solid #ccc;
        font-weight: bold;
        padding: 4px 5px;
      }
        .sub-ger-clu-pri > .quadrado > .titulo > div {
          display: inline-block;
          /* height: 25px; */
          line-height: 25px;
          vertical-align: middle;
        }
        .sub-ger-clu-pri > .quadrado > .titulo > div:first-child {
          width: calc(100% - 35px);
        }
        .sub-ger-clu-pri > .quadrado > .titulo > div:last-child {
          width: 35px;
          text-align: center;
        }
          .sub-ger-clu-pri > .quadrado > .titulo > div > svg {
            margin-right: 3px;
          }
          .sub-ger-clu-pri > .quadrado > .titulo > div > button {
            padding: 0px;
            width: 30px;
            height: 25px;
          }
        .sub-ger-clu-pri > .quadrado > .conteudo {
          width: 100%;
          padding: 5px;
          text-align: center;
          height: 83px;
          vertical-align: middle;
          display: table-cell;
          min-width: 187px;
        }
          /* .sub-ger-clu-pri > .quadrado > .conteudo > div {
            display: flex;
            align-items: center; 
            justify-content: center;
          } */
  .sub-ger-clu-pri > .habilitada > .conteudo > .editar > div {
    display: inline-block;
  }
    .sub-ger-clu-pri > .habilitada > .conteudo > .editar > .frase {
      display: block;
      margin-top: 5px;
    }
    .sub-ger-clu-pri > .habilitada > .conteudo > .editar > .cpnt-app-select.reduzido {
      width: 120px;
    }
    .sub-ger-clu-pri > .habilitada > .conteudo > .editar > .cpnt-app-calendario {
      width: 120px;
      margin-top: 10px;
    }
    .sub-ger-clu-pri > .habilitada > .conteudo > .editar > button {
      width: 80px;
      margin-top: 10px;
    }
  .sub-ger-clu-pri > .dias > .conteudo > .editar > button {
    width: 80px;
    margin-top: 10px;
  }
  .sub-ger-clu-pri > .notas > .conteudo > .editar > .cpnt-app-select:not(:first-child) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .sub-ger-clu-pri > .notas > .conteudo > .editar > .seletor-cobranca {
    margin-top: 0px !important;
    margin-bottom: 10px;
  }
  .sub-ger-clu-pri > .notas > .conteudo > div > img {
    width: 80px;
    vertical-align: -10px;
  }
  .sub-ger-clu-pri > .contrato > .conteudo > table {
    width: 100%;
  }
  .sub-ger-clu-pri > .certificado > .conteudo > table {
    width: 100%;
  }
    .sub-ger-clu-pri > .certificado > .conteudo > table > tr > td.icone {
      width: 40px;
    }
    .sub-ger-clu-pri > .certificado > .conteudo > table > tr > td.frase {
      width: calc(100% - 40px);
      text-align: center;
    }
</style>

<style>
  .sub-ger-clu-pri > .quadrado > .titulo > div > button > span > img {
    width: 15px;
    height: 15px;
  }
  .sub-ger-clu-pri > .quadrado > .titulo > div > button > span > span > svg {
    font-size: 15px;
  }
  .sub-ger-clu-pri > .quadrado > .conteudo > span > img,
  .sub-ger-clu-pri > .quadrado > .conteudo > table > tr > td > span > img {
    width: 30px;
    height: 30px;
    margin-top: 10px;
    text-align: center;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntClu: {
        require: true
      },

      cpntHabilitada: {
        require: true
      },
      cpntDataBlock: {
        require: true
      },
      cpntDataBlockDiff: {
        require: true
      },

      cpntContratoContadorFree: {
        require: true
      },
      cpntContratoLicencaUso: {
        require: true
      },
      cpntContratoDemonstrativo: {
        require: true
      },

      cpntNFeEmissor: {
        require: true
      },
      cpntNFeAmbiente: {
        require: true
      },
      cpntNFeCobranca: {
        require: true
      },
      cpntNFCeEmissor: {
        require: true
      },
      cpntNFCeAmbiente: {
        require: true
      },
      cpntNFCeCobranca: {
        require: true
      },
      cpntNFSeEmissor: {
        require: true
      },
      cpntNFSeAmbiente: {
        require: true
      },
      cpntNFSeCobranca: {
        require: true
      },

      cpntDiasTeste: {
        require: true
      },

      cpntDataCertificado: {
        require: true
      },
      cpntDataCertificadoDiff: {
        require: true
      },
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        editar: {
          hab:   { status: '', value: false },
          ndias: { status: '', value: false },
          nfe:   { status: '', value: false },
          nfce:  { status: '', value: false },
          nfse:  { status: '', value: false },
          senha: { status: '', value: false }
        },
        habilitada: {
          cor: ''
        },
        campos: {
          hab_seletor: {
            options: [
              { id: '1', nome: 'Sim' },
              { id: '0', nome: 'Bloquear' },
              { id: '2', nome: 'Cancelado' },
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: ''
          },
          hab_input: {
            value: ''
          },

          nfe_emissor: {
            options: [
              { id: 'mi', apiEnv: 'Migrate',     nome: 'Migrate' },
              { id: 'rf', apiEnv: 'RotinaFacil', nome: 'Rotina Fácil' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: ''
          },
          nfe_ambiente: {
            options: [
              { apiEnv: 'Homologacao',  id: '2', nome: 'Homologação' },
              { apiEnv: 'Producao',     id: '1', nome: 'Produção' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: ''
          },
          nfe_cobranca: {
            options: [
              { apiEnv: 'Bilhetagem',     id: '1', nome: 'Bilhetagem' },
              { apiEnv: 'Licenciamento',  id: '2', nome: 'Licenciamento' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            optionInicialNome: 'Selecione',
            value: '',
          },

          nfce_emissor: {
            options: [
              { id: 'mi', apiEnv: 'Migrate',     nome: 'Migrate' },
              { id: 'rf', apiEnv: 'RotinaFacil', nome: 'Rotina Fácil' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: ''
          },
          nfce_ambiente: {
            options: [
              { apiEnv: 'Homologacao',  id: '2', nome: 'Homologação' },
              { apiEnv: 'Producao',     id: '1', nome: 'Produção' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: ''
          },
          nfce_cobranca: {
            options: [
              { apiEnv: 'Bilhetagem',     id: '1', nome: 'Bilhetagem' },
              { apiEnv: 'Licenciamento',  id: '2', nome: 'Licenciamento' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            optionInicialNome: 'Selecione',
            value: '',
          },

          nfse_emissor: {
            options: [
              { id: 'mi', apiEnv: 'Migrate',     nome: 'Migrate' },
              { id: 'rf', apiEnv: 'RotinaFacil', nome: 'Rotina Fácil' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: ''
          },
          nfse_ambiente: {
            options: [
              { apiEnv: 'Homologacao',  id: '2', nome: 'Homologação' },
              { apiEnv: 'Producao',     id: '1', nome: 'Produção' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            value: '',
          },
          nfse_cobranca: {
            options: [
              { apiEnv: 'Bilhetagem',     id: '1', nome: 'Bilhetagem' },
              { apiEnv: 'Licenciamento',  id: '2', nome: 'Licenciamento' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            searchMinimo: 1000,
            optionInicialNome: 'Selecione',
            value: '',
          },

          ndias: {
            status: '',
            value: '',
            apiEnv: 'n_dias_teste'
          }
        }
      }
    },
    methods: {
      subGerCluPriEditarCampo: function (campo) {
        // SETA A VISUALIZAÇÃO DO CAMPO NA TELA
        this.editar[campo].value = !this.editar[campo].value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE SETAR O VALOR INICIAL
        if (this.editar[campo].value === true) {
          this.subGerCluPriSetarValorIni(campo)
        }
      },
      subGerCluPriSetarValorIni: function (campo) {
        // VERIFICA SE DEVE REALIZAR ALGUMA AÇÃO PARA O CAMPO
        switch (campo) {
          case 'hab':
            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.hab_seletor.value = this.cpntHabilitada

            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.hab_input.value = this.cpntDataBlock
            break

          case 'ndias':
            this.campos.ndias.value = this.cpntDiasTeste
            break

          case 'nfe':
            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfe_emissor.value = this.cpntNFeEmissor

            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfe_ambiente.value = this.cpntNFeAmbiente

            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfe_cobranca.value = this.cpntNFeCobranca
            break

          case 'nfce':
            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfce_emissor.value = this.cpntNFCeEmissor

            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfce_ambiente.value = this.cpntNFCeAmbiente
            
            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfce_cobranca.value = this.cpntNFCeCobranca
            break

          case 'nfse':
            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfse_emissor.value = this.cpntNFSeEmissor

            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfse_ambiente.value = this.cpntNFSeAmbiente

            // SETA A DATA DE BLOQUEIO RECEBIDA
            this.campos.nfse_cobranca.value = this.cpntNFSeCobranca
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subGerCluPriOnChange: function (value, campo) {
        // SETA O VALOR NOVO DO CAMPO
        this.campos[campo].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campos[campo].mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE REALIZAR ALGUMA AÇÃO PARA O CAMPO
        switch (campo) {
          case 'hab_seletor':
            if (value === '0' || value.id === '0') {
              if ([ '', null, undefined ].indexOf(this.campos.hab_input.value) !== -1) {
                // PEGA A DATA ATUAL
                var dataAtual = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY')
    
                // SOMA MAIS 7 DIAS
                var bloqueio = dataAtual.add(7, 'd')
    
                // A DATA DO BLOQUEIO SÓ PODE SER 2 = TERÇA, 3 = QUARTA, 4 = QUINTA, 5 = SEXTA
                while(bloqueio.day() <= 1 || bloqueio.day() >= 6) {
                  bloqueio = bloqueio.add(1, 'd')
                }
    
                // SETA A DATA DO BLOQUEIO CALCULADA
                this.campos.hab_input.value = bloqueio.format('DD/MM/YYYY')
              }
            }
            break
        }
      },
      subGerCluPriNomeCobranca: function (valor) {
        switch (valor) {
          case '2':
            return 'Bilhetagem'
          
          case '1':
            return 'Licenciamento'

          default:
            return '<span style="color: red;">ERRO (' + valor + ') COBRANÇA</span>'
        }
      },
      subGerCluPriNomeAmbiente: function (valor) {
        switch (valor) {
          case '2':
            return 'Homologação'
          
          case '1':
            return '<b>Produção</b>'

          default:
            return '<span style="color: red;">ERRO (' + valor + ') AMBIENTE</span>'
        }
      },
      subGerCluPriNomeEmissor: function (valor) {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = ''

        // VERIFICA O VALOR QUE DEVE COLOCAR
        switch (valor) {
          case 'mi':
            retorno += 'Migrate'
            break
          
          case 'rf':
            retorno += 'Rotina Fácil'
            break

          default:
            retorno += '<span style="color: red;">ERRO (' + valor + ') EMISSOR</span>'
            break
        }

        // FECHA O PARENTESES
        retorno += ''

        // RETORNA O VALOR MONTADO
        return retorno
      },
      subGerCluPriAtualizarSenhaSuporteRF: function () {
        // SETA O STATUS DO CAMPO
        this.editar.senha.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA O FORMULARIO PARA ENVIO API
        var formData = { clu: this.cpntClu }

        // SETA A NOVA SENHA DO SUPORTE RF
        formData.nova_senha = Math.floor((Math.random() * 99999999) + 10000000).toString()

        // PEGA APENAS OS 8 PRIMEIROS DIGITOS
        if (formData.nova_senha.length === 6) {
          formData.nova_senha = '0' + formData.nova_senha + '0'
        } else if (formData.nova_senha.length === 7) {
          formData.nova_senha = '0' + formData.nova_senha
        } else if (formData.nova_senha.length >= 8) {
          formData.nova_senha = formData.nova_senha.substring(0, 8)
        }
        
        // COLOCA CARCTERES ESPECIAIS NA SENHA
        formData.nova_senha = '_' + formData.nova_senha + '_'

        // FAZ A BUSCA DOS REGISTROS NA API
        this.$store.state.comunicaAPI('/subase/painel/clu-alt-sen-suporte', 'PUT', formData, (retorno) => {
          // CHAMA A FUNÇÃO PARA COPIAR A SENHA PARA O CTRL+C
          this.$store.commit('FUN_COPIAR_VALOR', { valor: formData.nova_senha, mensagem: 'API [200]: ' + retorno.message + ' Nova senha copiada para a área de transferência.' })

          // SETA O STATUS DO CAMPO
          this.editar.senha.status = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, (apiError) => {
          // SETA O STATUS DO CAMPO
          this.editar.senha.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, (apiValid, apiStatus) => {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
            // SETA O STATUS DO CAMPO
            this.editar.senha.status = ''
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        })
      },
      subGerCluPriAtualizarDiasTeste: function () {
        if (this.campos.ndias.value.toString() === this.cpntDiasTeste.toString()) {
          // SETA O STATUS DO CAMPO
          this.editar.ndias.status = ''
    
          // CHAMA A FUNÇÃO PARA FECHAR O CAMPO
          this.subGerCluPriEditarCampo('ndias')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          // SETA O STATUS DO CAMPO
          this.editar.ndias.status = 'carregando'
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // INICIA O FORMULARIO PARA ENVIO API
          var formData = { clu: this.cpntClu }
  
          // SETA A NOVA SENHA DO SUPORTE RF
          formData.n_dias_teste = this.campos.ndias.value
  
          // FAZ A BUSCA DOS REGISTROS NA API
          this.$store.state.comunicaAPI('/subase/painel/clu-alt-dias-teste', 'PUT', formData, (retorno) => {
            this.$emit('ATUALIZAR_DADOS', () => {
              // APRESENTA A MENSAGEM DE ERRO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
    
              // SETA O STATUS DO CAMPO
              this.editar.ndias.status = ''
    
              // CHAMA A FUNÇÃO PARA FECHAR O CAMPO
              this.subGerCluPriEditarCampo('ndias')
      
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          }, (apiError) => {
            // SETA O STATUS DO CAMPO
            this.editar.ndias.status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, (apiValid, apiStatus) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
              // SETA O STATUS DO CAMPO
              this.editar.ndias.status = ''
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        }
      },
      subGerCluPriAtualizarHabilitada: function () {
        // PEGA O VALOR SELECIONADO NO SELETOR
        var habSeletor = typeof this.campos.hab_seletor.value === 'string' ? this.campos.hab_seletor.value : this.campos.hab_seletor.value.id
        
        // VERIFICA SE TEVE ALTERAÇÃO
        if ((habSeletor.toString() !== this.cpntHabilitada.toString()) || (habSeletor === '0' && this.campos.hab_input.value.toString() !== this.cpntDataBlock.toString())) {          
          // SETA O STATUS DO CAMPO
          this.editar.hab.status = 'carregando'
          
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // INICIA O FROMUALRIO
          var formData = { clu: this.cpntClu }

          // VERIFICA A AÇÃO QUE DEVE SER FEITA
          switch (habSeletor) {
            case '1':
              formData.acao = 'l'
              break

            case '0':
              // SETA A AÇÃO DE BLOQUEIO
              formData.acao = 'b'

              // INFORMA A DATA DO BLOQUEIO
              formData.data = this.campos.hab_input.value
              break

            case '2':
              formData.acao = 'c'
              break
          }

          // FAZ A BUSCA DOS REGISTROS NA API
          this.$store.state.comunicaAPI('/subase/painel/clu-alt-status', 'PUT', formData, (retorno) => {
            this.$emit('ATUALIZAR_DADOS', () => {
              // APRESENTA A MENSAGEM DE ERRO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
    
              // SETA O STATUS DO CAMPO
              this.editar.hab.status = ''
    
              // CHAMA A FUNÇÃO PARA FECHAR O CAMPO
              this.subGerCluPriEditarCampo('hab')
      
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          }, (apiError) => {
            // SETA O STATUS DO CAMPO
            this.editar.hab.status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, (apiValid, apiStatus) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
              // SETA O STATUS DO CAMPO
              this.editar.hab.status = ''
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        } else {
          // SETA O STATUS DO CAMPO
          this.editar.hab.status = ''
    
          // CHAMA A FUNÇÃO PARA FECHAR O CAMPO
          this.subGerCluPriEditarCampo('hab')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      subGerCluPriAtualizarDadosNotaFiscal: function (chave) {
        // VERIFICA A CHAVE QUE DEVE USAR
        var chaveA = chave + '_ambiente'
        var chaveE = chave + '_emissor'
        var chaveC = chave + '_cobranca'

        // INICIA A CHAVE DE COMPARAÇÃO
        var comparaA = ''
        var comparaE = ''
        var comparaC = ''

        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { clu: this.cpntClu }
        
        // VERIFICA A DIFERENÇA A SER USADA
        switch(chave) {
          case 'nfe':
            // SETA OS VALORES PARA COMPARAÇÃO
            comparaA = this.cpntNFeAmbiente
            comparaE = this.cpntNFeEmissor
            comparaC = this.cpntNFeCobranca

            // SETA O MODELO QUE ESTÁ SENDO ALTERADO
            formData.doc_modelo = 'NFe'
            break

          case 'nfce':
            // SETA OS VALORES PARA COMPARAÇÃO
            comparaA = this.cpntNFCeAmbiente
            comparaE = this.cpntNFCeEmissor
            comparaC = this.cpntNFCeCobranca

            // SETA O MODELO QUE ESTÁ SENDO ALTERADO
            formData.doc_modelo = 'NFCe'
            break
          
          case 'nfse':
            // SETA OS VALORES PARA COMPARAÇÃO
            comparaA = this.cpntNFSeAmbiente
            comparaE = this.cpntNFSeEmissor
            comparaC = this.cpntNFSeCobranca

            // SETA O MODELO QUE ESTÁ SENDO ALTERADO
            formData.doc_modelo = 'NFSe'
            break
        }

        // PEGA O VALOR SELECIONADO NO SELETOR
        var optionA = this.campos[chaveA].value
        if (typeof optionA === 'string') {
          optionA = this.campos[chaveA].options.filter(item => item.id === optionA)[0]
        }
        var optionE = this.campos[chaveE].value
        if (typeof optionE === 'string') {
          optionE = this.campos[chaveE].options.filter(item => item.id === optionE)[0]
        }
        var optionC = this.campos[chaveC].value
        if (typeof optionC === 'string') {
          optionC = this.campos[chaveC].options.filter(item => item.id === optionC)[0]
        }
        
        // VERIFICA SE OCORREU ALTERAÇÃO
        if ((optionA.id !== comparaA) || (optionE.id !== comparaE) || (optionC.id !== comparaC)) {
          // SETA O STATUS DO CAMPO
          this.editar[chave].status = 'carregando'
          
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA O NOVO VALOR PARA O EMISSOR
          formData.emissor = optionE.apiEnv

          // SETA O NOVO VALOR PARA AMBIENTE
          formData.ambiente = optionA.apiEnv

          // SETA O NOVO VALOR PARA AMBIENTE
          if (formData.emissor !== 'RotinaFacil' && formData.ambiente === 'Producao') {
            formData.tipo_cobranca = optionC.apiEnv
          }

          // FAZ A BUSCA DOS REGISTROS NA API
          this.$store.state.comunicaAPI('/subase/painel/clu-alt-amb-fiscal', 'PUT', formData, (retorno) => {
            this.$emit('ATUALIZAR_DADOS', () => {
              // APRESENTA A MENSAGEM DE ERRO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
    
              // SETA O STATUS DO CAMPO
              this.editar[chave].status = ''
    
              // CHAMA A FUNÇÃO PARA FECHAR O CAMPO
              this.subGerCluPriEditarCampo(chave)
      
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          }, (apiError) => {
            // SETA O STATUS DO CAMPO
            this.editar[chave].status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, (apiValid, apiStatus) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
              // SETA O STATUS DO CAMPO
              this.editar[chave].status = ''
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        } else {
          // SETA O STATUS DO CAMPO
          this.editar[chave].status = ''
    
          // CHAMA A FUNÇÃO PARA FECHAR O CAMPO
          this.subGerCluPriEditarCampo(chave)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      }
    },
    computed: {
      subGerCluPriFraseBloqueio: function () {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = ''

        // VERIFICA SE TEM UMA DATA PARA COLOCAR NA MENSAGEM
        if ([ '', null, undefined ].indexOf(this.campos.hab_input.value) === -1 && (this.campos.hab_seletor.value === '0' || this.campos.hab_seletor.value.id === '0')) {
          // PEGA A DATA ATUAL
          var dataAtual = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY')
  
          // CONVERTE A DATA DO BLOQUEIO
          var bloqueio = moment(this.campos.hab_input.value, 'DD/MM/YYYY')
  
          // CALCULA A DIFERENÇA DAS DATAS
          var diff = bloqueio.diff(dataAtual, 'days')
  
          // INICIA A FRASE
          retorno = (diff > 0 ? 'O cliente será bloqueado <br/>após ' : '<span style="color: red;">O cliente está bloqueado hà ')
          
          // SETA O NUMERO DE DIAS
          retorno += (diff < 0 ? (diff * (-1)) : diff) + ' dia' + (diff > 1 ? 's' : '') + '.</span>'
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      subGerCluPriFraseCertificado: function () {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = ''

        // VERIFICA QUAL FRASE DEVE COLOCAR
        if (this.cpntDataCertificadoDiff <= 0) {
          retorno = "VENCIDO há " + (this.cpntDataCertificadoDiff * (-1)) + " dia(s)."
        } else {
          retorno = "Certificado vence em " + this.cpntDataCertificado + " totalizando " + this.cpntDataCertificadoDiff + " dias."
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      subGerCluPriFraseEmissorNFe: function () {
        return this.subGerCluPriNomeEmissor(this.cpntNFeEmissor)
      },
      subGerCluPriFraseAmbienteNFe: function () {
        return this.subGerCluPriNomeAmbiente(this.cpntNFeAmbiente)
      },
      subGerCluPriFraseCobrancaNFe: function () {
        return this.subGerCluPriNomeCobranca(this.cpntNFeCobranca)
      },
      subGerCluPriValorSelEmissorNFe: function () {
        return typeof this.campos.nfe_emissor.value === 'string' ? this.campos.nfe_emissor.value : this.campos.nfe_emissor.value.id
      },
      subGerCluPriValorSelAmbienteNFe: function () {
        return typeof this.campos.nfe_ambiente.value === 'string' ? this.campos.nfe_ambiente.value : this.campos.nfe_ambiente.value.id
      },
      subGerCluPriFraseEmissorNFCe: function () {
        return this.subGerCluPriNomeEmissor(this.cpntNFCeEmissor)
      },
      subGerCluPriFraseAmbienteNFCe: function () {
        return this.subGerCluPriNomeAmbiente(this.cpntNFCeAmbiente)
      },
      subGerCluPriFraseCobrancaNFCe: function () {
        return this.subGerCluPriNomeCobranca(this.cpntNFCeCobranca)
      },
      subGerCluPriValorSelEmissorNFCe: function () {
        return typeof this.campos.nfce_emissor.value === 'string' ? this.campos.nfce_emissor.value : this.campos.nfce_emissor.value.id
      },
      subGerCluPriValorSelAmbienteNFCe: function () {
        return typeof this.campos.nfce_ambiente.value === 'string' ? this.campos.nfce_ambiente.value : this.campos.nfce_ambiente.value.id
      },
      subGerCluPriFraseEmissorNFSe: function () {
        return this.subGerCluPriNomeEmissor(this.cpntNFSeEmissor)
      },
      subGerCluPriFraseAmbienteNFSe: function () {
        return this.subGerCluPriNomeAmbiente(this.cpntNFSeAmbiente)
      },
      subGerCluPriFraseCobrancaNFSe: function () {
        return this.subGerCluPriNomeCobranca(this.cpntNFSeCobranca)
      },
      subGerCluPriValorSelAmbienteNFSe: function () {
        return typeof this.campos.nfse_ambiente.value === 'string' ? this.campos.nfse_ambiente.value : this.campos.nfse_ambiente.value.id
      },
      subGerCluPriValorSelEmissorNFSe: function () {
        return typeof this.campos.nfse_emissor.value === 'string' ? this.campos.nfse_emissor.value : this.campos.nfse_emissor.value.id
      },
    }
  }
</script>
